<template>
	<div class="mask"></div>
</template>
<script >
	
	export default{
		name:'paco-mask'
	}
</script>




// WEBPACK FOOTER //
// Mask.vue?411350dc